import { configureStore, combineReducers } from "@reduxjs/toolkit"
import globalReducer from "./reducer/GlobalReducer";
import assetsReducer from "./reducer/assets/AssetsReducer";
import dashboardReducer from "./reducer/dashboard/DashboardReducer";
import demographicsReducer from "./reducer/demographics/DemographicsReducer";
import organizationReducer from "./reducer/organization/OrganizationReducer";
import profileReducer from "./reducer/profile/ProfileReducer";
import eventReducer from "./reducer/event/EventReducer";
import participantReducer from "./reducer/participant/ParticipantReducer";
import donationReducer from "./reducer/donation/DonationReducer";

const rootReducer = combineReducers({
    ...globalReducer,
    ...assetsReducer,
    ...dashboardReducer,
    ...demographicsReducer,
    ...organizationReducer,
    ...profileReducer,
    ...eventReducer,
    ...participantReducer,
    ...donationReducer,
});

const arokkiyam_store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default arokkiyam_store;